<template>
    <v-dialog
        v-model="show"
        width="700"
        @click:outside="close"
    >
        <v-card>
            <v-card-title 
                class="text-h5 white--text"
                style="background-color:#5087e6;"
            >
                幫助
                <v-icon right class="text-h5 white--text">
                    mdi-help-circle-outline
                </v-icon>
            </v-card-title>
            <v-container>
                <slot name="subtitle"></slot>
                <slot name="content"></slot>
                <slot name="footer"></slot>
                <slot name="actions"></slot>
            </v-container>
        </v-card>
    </v-dialog>    
</template>

<script>
export default {
    name: "HelpDialog",
    components: {

    },
    data() {
        return {
            show: true,
            
        }
    },
    created() {

    },
    mounted() {
        console.log(" yo HelpDialog ");
    },
    methods: {
        close() {
            this.$emit('close')
        }
    },
    computed: {

    },
    watch: {

    }
}
</script>

<style scoped>

</style>